// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalizationMessage_container__XPblc"};